import request from '@/plugin/axios'
import axios from 'axios';



export function batchBackCase(data) {
    return request({
        url: "/api/case/czCaseInfo/batchWithdrawalCase",
        method: "put",
        data
    });
}

export function getMediateNumberList() {
    return request({
        url: "/api/admin/user/getUserName",
        method: "get",

    });
}

export function deleteMediateData(id) {
    return request({
        url: "/api/case/czMediate/deleteMediateMessage/" + id,
        method: "delete",

    });
}
export function batchRegister(data) {
    return request({
        url: "/api/case/czCaseInfo/batchDeadlinePayDate",
        method: "put",
        data
    });
}
export function uploadTable(data, token) {
    return axios({
        url: process.env.VUE_APP_API + "/api/case/czCaseInfo/importCaseExcel",
        method: "post",
        dataType: "json",
        responseType: "application/json",
        data: data,
        headers: {
            authorization: "Bearer " + token,
        },
    });
}

export function uploadSingleFile(data, token, url) {
    return axios({
        url: process.env.VUE_APP_API + url,
        method: "post",
        dataType: "json",
        responseType: "application/json",
        data: data,
        headers: {
            authorization: "Bearer " + token,
        },
    });
}

export function addCaseRemark(data) {
    return request({
        url: '/api/case/czCaseRemarkLog/addLog',
        method: 'post',
        data
    })
}
export function page(query) {
    return request({
        url: '/api/case/czCaseInfo/caseList',
        method: 'post',
        data: query
    })
}
export function addCaseInfo(data, token) {
    return axios({
        url: process.env.VUE_APP_API + '/api/case/czCaseInfo/caseBaseInfo',
        method: 'post',
        dataType: 'json',
        responseType: 'application/json',
        data: data,
        headers: {
            authorization: 'Bearer ' + token,
        },

    })
}
export function searchCaseInfo(obj) {
    return request({
        url: '/api/case/czCaseInfo',
        method: 'post',
        data: obj
    })
}
export function selectBank() {
    return request({
        url: '/api/case/czBankInfo/selectMap',
        method: 'get',
    })
}


export function addSingleDefendant(data) {
    return request({
        url: "/api/case/czCaseInfo/addSingleDefendant",
        method: "post",
        responseType: 'application/json',
        data
    })
}
export function selectAgent() {
    return request({
        url: "/api/case/czAgent/selectMap",
        method: "get"
    })
}
export function selectConfigMap(name) {
    return request({
        url: "/api/case/commonConfig/getSelectMap?configName=" + name,
        method: "get"
    })
}

export function selectCause() {
    return request({
        url: "/api/case/commonConfig/getSelectMap?configName=cause",
        method: "get"
    })
}

export function getObj(id) {
    return request({
        url: '/api/case/czCaseInfo/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/api/case/czCaseInfo/' + id,
        method: 'delete'
    })
}

export function putObj(id, obj) {
    return request({
        url: '/api/case/czCaseInfo/' + id,
        method: 'put',
        data: obj
    })
}


export function setAgent(data) {
    return request({
        url: '/api/case/czCaseAgent/setBatchAgent',
        method: 'post',
        data: data
    })
}

export function deletetCase(id) {
    return request({
        url: '/api/case/czCaseInfo/delete/' + id,
        method: 'delete'
    })
}


export function batchDeletetCase(data) {
    return request({
        url: '/api/case/czCaseInfo/batchDelete',
        method: 'post',
        data: data
    })
}
export function setCaseStatus(data) {
    return request({
        url: '/api/case/czCaseInfo/batchSetStatus',
        method: "post",
        data
    })
}
export function validateNull(data) {
    return request({
        url: '/api/case/czCaseInfo/validateNull',
        method: "post",
        data
    })
}

export function expLedger(data, token) {
    return axios({
        url: process.env.VUE_APP_API + '/api/case/czCaseInfo/expLedger',
        method: 'post',
        data,
        responseType: "arraybuffer",
        headers: {
            authorization: 'Bearer ' + token
        }
    })
}

export function expBankExcel(params, token) {
    return axios({
        url: process.env.VUE_APP_API + '/api/case/czCaseInfo/expBankLedger',
        method: 'post',
        data: params,
        responseType: "arraybuffer",
        headers: {
            authorization: 'Bearer ' + token
        }
    })
}

export function expBankLedgerByJieSuan(params, token) {
    return axios({
        url: process.env.VUE_APP_API + '/api/case/czCaseInfo/expBankLedgerByJieSuan',
        method: 'post',
        data: params,
        responseType: "arraybuffer",
        headers: {
            authorization: 'Bearer ' + token
        }
    })
}


export function getCourtList() {
    return request({
        url: '/api/case/commonConfig/getSelectMap?configName=courtName',
        method: "get"
    })
}



export function getCaseStatusList() {
    return request({
        url: '/api/case/commonConfig/getSelectMap?configName=caseStatus',
        method: "get"
    })
}

export function getaAreementList() {
    return request({
        url: '/api/case/commonConfig/getSelectMap?configName=agreement',
        method: "get"
    })
}
export function getStagesScheme() {
    return request({
        url: "/api/case/commonConfig/getSelectMap?configName=installmentAgreementName",
        method: "get"
    })
}
export function getApplicationType() {
    return request({
        url: "/api/case/commonConfig/getSelectMap?configName=applyTitle",
        method: "get"
    })
}
export function expWebExcel(data, token) {
    return axios({
        url: process.env.VUE_APP_API + '/api/case/czCaseInfo/expServiceWebExcel',
        method: 'post',
        data,
        responseType: "arraybuffer",
        headers: {
            authorization: 'Bearer ' + token
        }
    })
}
export function copyCaseById(caseId) {
    return request({
        url: '/api/case/czCaseInfo/copyCaseInfo/' + caseId,
        method: 'post',
    })
}


export function expGaoZhouDoc(data, token) {
    return axios({
        url: process.env.VUE_APP_API + "/api/case/czCaseInfo/createGaoZhouDocument",
        method: "post",
        data: data,
        responseType: "arraybuffer",
        headers: {
            authorization: "Bearer " + token,
        },
    })
}
//转立案
export function switchRegister(caseId) {
    return request({
        url: '/api/case/czCaseInfo/caseRegister/' + caseId,
        method: 'put',
    })
}
//录入缴费截止日期
export function deadlinePayDate(params) {
    return request({
        url: '/api/case/czCaseInfo/deadlinePayDate',
        method: 'put',
        data: params
    })
}
//确认缴费
export function confirmPayment(caseId) {
    return request({
        url: '/api/case/czCaseInfo/confirmPayment/' + caseId,
        method: 'put',
    })
}
// 录入开庭时间
export function setTrialDate(params) {
    return request({
        url: '/api/case/czCaseInfo/setTrialDate',
        method: 'put',
        data: params
    })
}

//确认调单
export function confirmDiaoDang(caseId) {
    return request({
        url: '/api/case/czCaseInfo/confirmDiaoDang/' + caseId,
        method: 'put',
    })
}
//
export function fulfillmentDate(data) {
    return request({
        url: '/api/case/czCaseInfo/fulfillmentDate',
        method: 'put',
        data
    })
}
// 已履行
export function performance(obj) {
    return request({
        url: '/api/case/czCaseInfo/caseComplete',
        method: 'put',
        data: obj
    })
}


// 为履行
export function noPerformance(caseId) {
    return request({
        url: '/api/case/czCaseInfo/noPerformance/' + caseId,
        method: 'put',
    })
}
// 需要二次开庭
export function enterVerdict(caseId) {
    return request({
        url: '/api/case/czCaseInfo/enterVerdict/' + caseId,
        method: 'put',
    })
}

// 二次排期
export function reScheduleg(caseId) {
    return request({
        url: '/api/case/czCaseInfo/reScheduleg/' + caseId,
        method: 'put',
    })
}

export function createConstructionTable(token, data) {
    return axios({
        url: process.env.VUE_APP_API + "/api/case/czCaseInfo/createApprovalTable",
        method: "post",
        data: data,
        responseType: "arraybuffer",
        headers: {
            authorization: "Bearer " + token,
        },
    })
}

export function caseMediate(caseId) {
    return request({
        url: '/api/case/czCaseInfo/caseMediate/' + caseId,
        method: 'put',
    })
}


export function setMediateDate(data) {
    return request({
        url: '/api/case/czCaseInfo/setMediateDate',
        method: 'put',
        data: data
    })
}

export function submitMediateCase(id) {
    return request({
        url: '/api/case/czMediate/mediationForcing/' + id,
        method: 'post',
    })
}
export function addMediateMessage(entity) {
    return request({
        url: '/api/case/czMediate/addMediateMessage',
        method: 'post',
        data: entity
    })
}
export function getMediateMessage(caseId) {
    return request({
        url: '/api/case/czMediate/getOneMediateMessage/' + caseId,
        method: 'get',
    })
}

export function updateMediateMessage(id, entity) {
    return request({
        url: '/api/case/czMediate/updateMediateMessage',
        method: 'put',
        data: entity
    })
}
export function breakMediate(caseId) {
    return request({
        url: '/api/case/czCaseInfo/breakMediate/' + caseId,
        method: 'put',
    })
}
export function getProductName() {
    return request({
        url: '/api/case/commonConfig/getSelectMap?configName=productName',
        method: 'get',
    })
}
export function getFenQiClass() {
    return request({
        url: '/api/case/commonConfig/getSelectMap?configName=installmentType',
        method: 'get',
    })
}

export function upLoadCaseFile(data) {
    return request({
        url: "/api/case/czCaseFiles/upload",
        method: "post",
        responseType: 'application/json',
        data
    })
}

export function getCaseUploadFile(caseId) {
    return request({

        url: "/api/case/czCaseFiles/caseFileList/" + caseId,
        method: "get",
    })
}
export function downCaseUploadFile(id, token) {


    return axios({
        url: process.env.VUE_APP_API + "/api/case/czCaseFiles/downloadFile/" + id,
        method: "get",
        responseType: "arraybuffer",
        headers: {
            authorization: 'Bearer ' + token,
        },
    })

}
export function deleteCaseUploadFile(id) {
    return request({

        url: "/api/case/czCaseFiles/deleteFile/" + id,
        method: "delete",
    })
}
export function withDraw(data) {
    return request({
        url: '/api/case/czCaseInfo/dropLawsuit',
        method: 'put',
        data
    })
}
export function backCase(data) {
    return request({
        url: '/api/case/czCaseInfo/withdrawalCase',
        method: 'put',
        data
    })
}
export function backToStart(id) {
    return request({
        url: '/api/case/czCaseInfo/backToStart/' + id,
        method: 'put'
    })
}

export function getCourtStatistics(data) {
    return request({
        url: '/api/case/czCaseInfo/courtStatistics',
        method: 'get',
        params: data
    })
}
export function geBankStatistics(data) {
    return request({
        url: '/api/case/czCaseInfo/bankStatistics',
        method: 'get',
        params: data
    })
}
export function getCountAndBankStatistics(data) {
    return request({
        url: '/api/case/czCaseInfo/countAndBankStatistics',
        method: 'get',
        params: data
    })

}
export function getCaseViewData(data) {
    return request({
        url: "/api/case/czCaseInfo/statistics",
        method: 'get',
        params: data
    })
}

export function settleDate(data) {
    return request({
        url: "/api/case/czCaseInfo/setSettleDate",
        method: 'post',
        data
    })
}


export function confirmDropLawsuit(data) {
    return request({
        url: "/api/case/czCaseInfo/confirmDropLawsuit",
        method: 'put',
        data
    })
}

export function calculationCardAmount(id) {
    return request({
        url: "/api/case/czCaseInfo/calculationCardAmount/" + id,
        method: 'get'
    })
}

export function previewUrl(id) {
    return request({
        url: "/api/case/czCaseFiles/previewUrl/" + id,
        method: 'get'
    })
}


export function directUpload(data) {
    return request({
        url: "/api/case/czCaseFiles/directUpload/",
        method: 'post',
        data
    })
}

export function backCaseStatusApi(data) {
    return request({
        url: "/api/case/czCaseStatus/backCaseStatus/",
        method: 'post',
        data
    })
}

export function caseStatusList(id) {
    return request({
        url: "/api/case/czCaseStatus/caseStatusList/" + id,
        method: 'get'
    })
}

export function setArchivingDate(data) {
    return request({
        url: '/api/case/czCaseInfo/setCaseArchivingDate',
        method: 'put',
        data
    })
}